<div class="d-flex flex-fill flex-column">
  <div class="toolbar-container filters-box p-0 mb-3 border-bottom-0">
    <ng-container *ngTemplateOutlet="tmplToolbar"></ng-container>
  </div>
  <div class="d-flex flex-fill flex-column container-box">
    <div class="calendar-container">
      <ng-container *ngTemplateOutlet="tmplCalendar"></ng-container>

      <div
        class="btn-navigate btn-navigate-prev"
        (click)="navigate('prev')"
        [ngStyle]="{
          'left.px': config.sidebarWidth + 1,
          'height.px': config.headerHeight - 2
        }"
      >
        <i class="fal fa-chevron-left"></i>
      </div>
      <div
        class="btn-navigate btn-navigate-next"
        (click)="navigate('next')"
        [ngStyle]="{
          'height.px': config.headerHeight - 2
        }"
      >
        <i class="fal fa-chevron-right"></i>
      </div>
      <div
        class="sidebar-shadow"
        [ngStyle]="{ 'left.px': config.sidebarWidth, 'bottom.px': calendar?.scrollbarSizes.content || 0 }"
      ></div>
    </div>
    <mat-paginator2
      #paginator
      (page)="onChangePage($event)"
      [length]="filteredRentals.length"
      [class.hidden]="!filteredRentals.length"
      [pageIndex]="activePage"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100, 200]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>
  </div>
</div>

<ng-template #tmplToolbar>
  <div class="d-flex align-items-center gap-2">
    <ng-content select="[title]"></ng-content>
  </div>

  <div class="spacer"></div>

  <div class="btn-holder gap-3">
    <button
      class="btn btn-secondary-primary"
      (click)="onRefresh()"
      matTooltip="Refresh Calendar"
      matTooltipPosition="above"
      i18n-matTooltip
    >
      <i class="far fa-sync"></i>
    </button>
    <ng-container *ngTemplateOutlet="tmplFieldAvailability"></ng-container>
    <button
      class="btn btn-outline-light"
      (click)="gotoToday()"
      matTooltip="Go to Today"
      matTooltipPosition="above"
      i18n-matTooltip
      i18n
    >
      Today
    </button>

    <app-select-nav class="field-years" (previous)="onChangeYear('prev')" (next)="onChangeYear('next')">
      <mat-select [(ngModel)]="selectedYear" (selectionChange)="onChangeYear()">
        <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </app-select-nav>

    <app-select-nav class="field-months" (previous)="onChangeMonth('prev')" (next)="onChangeMonth('next')">
      <mat-select [(ngModel)]="selectedMonth" (selectionChange)="onChangeMonth()">
        <mat-option *ngFor="let month of months" [value]="month">
          {{ month | epochUTC : 'MMM' }}
        </mat-option>
      </mat-select>
    </app-select-nav>
    <app-cancel-filters
      [isFiltering]="filters | isFiltering : isFilteringIgnoreFields"
      (click)="clearFilters()"
    ></app-cancel-filters>
    <div class="btn-group dropdown-filters" dropdown [autoClose]="autoCloseDropdownFilters">
      <button
        type="button"
        class="btn btn-secondary-primary dropdown-toggle"
        [class.btn-filters-active]="!!filtersCount"
        dropdownToggle
      >
        <span class="fal fa-filter"></span>
        <ng-container i18n>Filters</ng-container>
      </button>
      <ul
        class="dropdown-menu dropdown-menu-right"
        *dropdownMenu
        (click)="$event.stopPropagation()"
        style="max-width: 400px"
      >
        <li>
          <app-rental-select
            [items]="rentalsWithoutSubUnits"
            [ctrl]="filters.get('rentals')"
            (openedChange)="autoCloseDropdownFilters = !$event"
            placeholder="Rentals"
            i18n-placeholder
            label="Rentals"
            i18n-label
            class="w-auto"
            matTooltip="Select rentals to filter list."
            matTooltipPosition="above"
            i18n-matTooltip
          >
          </app-rental-select>
        </li>
        <li>
          <app-entity-filter-tags
            matTooltip="Select rental tags to filter list."
            matTooltipPosition="above"
            i18n-matTooltip
            [inline]="false"
            [tags]="filterTags"
            [ctrl]="filters.get('tags')"
            [entityIdsCtrl]="filters.get('taggedIds')"
            (openedChange)="autoCloseDropdownFilters = !$event"
            type="rental"
            placeholder="Tags"
            i18n-placeholder
          ></app-entity-filter-tags>
        </li>
        <li>
          <app-select-search
            [inline]="false"
            [items]="filterChannels"
            [ctrl]="filters.get('channels')"
            (openedChange)="autoCloseDropdownFilters = !$event"
            placeholder="Sources"
            i18n-placeholder
            class="w-auto"
            matTooltip="Select sources to only see bookings from those sources."
            matTooltipPosition="above"
            i18n-matTooltip
          >
          </app-select-search>
        </li>
        <li class="pb-2">
          <mat-checkbox [formControl]="filters.get('double')" i18n>Only show Double Booked Rentals</mat-checkbox>
        </li>
        <li class="pb-2">
          <mat-checkbox [formControl]="filters.get('hideRates')" i18n>Hide Rates</mat-checkbox>
        </li>
      </ul>
    </div>
    <div *ngIf="isOwner" class="btn-group">
      <button
        type="button"
        class="btn btn-secondary-info"
        (click)="onAddHoldEvent()"
        [disabled]="1 | isReadonlyRole"
        matTooltip="Block dates on your calendar and make them unavailable for booking."
        matTooltipPosition="left"
        i18n-matTooltip
      >
        <span class="fal fa-calendar-plus"></span> Add Hold
      </button>
    </div>
    <ng-template *ngxPermissionsOnly="['canSeeCalendarActions']" [ngTemplateOutlet]="addActions"></ng-template>
  </div>
</ng-template>

<ng-template #tmplCalendar>
  <ngx-multi-event-calendar
    #calendar
    [config]="config"
    [items]="pageRentals"
    [events]="filteredEvents"
    [showCoveredCells]="false"
    [loading]="loading"
    [getEventID]="getEventID"
    [getEventTimeRange]="getEventTimeRange"
    (viewportChange)="onViewportChange($event)"
    (selectionChange)="onSelectionChange($event)"
    [class.calendar-empty]="!filteredRentals.length"
  >
    <div class="calendar-sidebar-header px-2" *ngxMultiEventCalendarSidebarHeader>
      <mat-form-field2
        [showLabel]="false"
        class="mat-block"
        matTooltip="Search by rental name or rental's nickname"
        i18n-matTooltip
      >
        <i matPrefix class="fal fa-search"></i>
        <input matInput placeholder="Search" i18n-placeholder [formControl]="filters.get('search')" />

        <mat-spinner *ngIf="loading" matSuffix diameter="16"></mat-spinner>
      </mat-form-field2>
    </div>

    <div
      class="calendar-header-cell"
      *ngxMultiEventCalendarHeaderCell="let date"
      [ngClass]="'week-' + (date | epochUTC : 'd')"
    >
      <div class="subtext">{{ date | epochUTC : 'ddd' }}</div>
      <div class="text">
        <ng-template #dateView> {{ date | epochUTC : 'DD' }}</ng-template>
        <span *ngIf="date | isUTCTimeStartOf : 'month'; else dateView">{{ date | epochUTC : 'MMM' }}</span>
      </div>
    </div>

    <div
      class="calendar-sidebar-cell d-flex align-items-center gap-2 pr-1 w-100 clickable"
      *ngxMultiEventCalendarSidebarCell="let rental"
      [ngStyle]="{
        'border-left-color': rental.color || defaultRentalColor,
        'padding-left': rental.parent_id || rental.multi_unit_id ? '22px' : '0.25rem'
      }"
      #sidebarCell
      (click)="onOpenRental(rental)"
      [matTooltip]="rental.nickname || rental.name"
      matTooltipPosition="right"
    >
      <app-rental-group-label
        class="position-absolute"
        [style.left.px]="-22"
        [height]="sidebarCell.offsetHeight"
        [rental]="rental"
        [style.filter]="(rental | isSubunit) && !rental.multi_unit_status ? 'grayscale(100%)' : 'none'"
      ></app-rental-group-label>
      <app-rental-image [rental]="rental" [size]="40"></app-rental-image>
      <div class="flex-fill text-truncate" [class.text-light]="(rental | isSubunit) && !rental.multi_unit_status">
        <div class="text-truncate">
          {{ rental.nickname || rental.name }}
        </div>
        <div class="d-flex align-items-center gap-2 text-sm">
          <app-rental-status-icon [rental]="rental" *ngxPermissionsOnly="['canEditRental']"></app-rental-status-icon>
          <span class="">{{ rental.bedrooms || 0 }} <i class="fas fa-bed-front"></i></span>
          <span class="">{{ rental.bathrooms || 0 }} <i class="fas fa-bath"></i></span>
        </div>
      </div>
      <div
        (click)="onExpandMainUnit(rental); $event.stopPropagation()"
        class="p-2 clickable"
        *ngIf="rental | isMainUnit"
      >
        <i class="far" [ngClass]="rental.id === expandedRentalId$.value ? 'fa-angle-down' : 'fa-angle-right'"></i>
      </div>
    </div>

    <div
      class="calendar-event-cell clickable"
      *ngxMultiEventCalendarEventCell="let event; let rental = item; let overlaps = overlaps"
      (click)="showEventDetails(event)"
      [appBookingDetails]="event"
      [appBookingDetailsRental]="rental"
      [style.borderLeftColor]="event.color"
      [ngbPopover]="event.bookingId ? tmplBookingTooltip : tmlHoldTooltip"
      #popover="ngbPopover"
      container="body"
      placement="auto"
      popoverClass="popover-fill-content dropdown-shadow"
      triggers="manual"
      [autoClose]="true"
      (mouseenter)="popover.open({ rental: rental, event: event })"
      (mouseleave)="popover.close()"
    >
      <div class="calendar-event">
        <img
          *ngIf="!event.isHoldEvent"
          draggable="false"
          class="icon"
          [src]="event.source | inquirySourceIcon"
          alt=""
        />
        <div class="text">
          {{ event.titleView }}
          <b *ngIf="event.bookingId && (canSeeCharges$ | async)">
            <br />
            {{ getBookingEventCost | call : event | tokeetCurrency : rental.currency }}
          </b>
        </div>
      </div>
    </div>
    <ng-container *ngxMultiEventCalendarContentCell="let rental = item; let date = date">
      <div
        class="w-100 h-100 d-flex flex-column"
        [ngClass]="['week-' + (date | epochUTC : 'd'), !!rental.multi_unit_id ? 'multi-unit' : '']"
        [class.multi-unit-booked]="(rental | isMainUnit) && !getAvailableUnits(rental.id, date)?.length"
      >
        <ng-container *ngxPermissionsOnly="['canSeeRates']">
          <ng-container *ngIf="!filters.get('hideRates').value && !isBooked(rental.id, date)">
            <div
              *ngIf="getDefaultRate | call : rentalRatesByCategory : rental : date; let rate"
              class="calendar-rate-text text-center text-truncate p-1 flex-1 d-flex flex-column"
              [ngbPopover]="tmplRateTooltip"
              #popover="ngbPopover"
              container="body"
              placement="auto"
              popoverClass="popover-fill-content dropdown-shadow"
              triggers="manual"
              [autoClose]="true"
              (mouseenter)="popover.open({ rental: rental, date: date, rate: rate })"
              (mouseleave)="popover.close()"
            >
              <div>{{ rate.price | rate : rate.currency }}</div>
              <div *ngIf="rate.minimumstay != null" class="calendar-minimum-stay mt-auto">
                {{ rate.minimumstay }}
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="multi-unit-availability mt-auto ml-auto text-muted text-xs" *ngIf="rental | isMainUnit">
          {{ getBookedOnAvailableUnits(rental.id, date) }}
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!loading && !filteredRentals.length">
      <app-empty-table
        *ngxMultiEventCalendarEmptySidebar
        [type]="tableTypes.CalendarSidebarRentals"
        [isFiltering]="rentalsWithoutSubUnits.length"
        class="empty-list"
        [style.opacity]="rentalsWithoutSubUnits.length ? 0 : 1"
      >
        <ng-container *ngxPermissionsOnly="['canEditRental']">
          <app-button
            *ngIf="!rentalsWithoutSubUnits.length"
            (click)="onAddRental()"
            icon="far fa-plus"
            class="btn btn-secondary-info mt-4"
          >
            <ng-container i18n>Add Rental</ng-container>
          </app-button>
        </ng-container>
      </app-empty-table>

      <app-empty-table
        *ngxMultiEventCalendarEmptyContent
        [type]="tableTypes.CalendarContentRentals"
        class="empty-events"
      >
      </app-empty-table>
    </ng-container>
  </ngx-multi-event-calendar>
</ng-template>

<ng-template #tmplFieldAvailability>
  <div class="btn-group">
    <button
      matTooltip="Show rentals available during selected dates."
      matTooltipPosition="above"
      i18n-matTooltip
      class="btn calender-ctrl-btn text-nowrap"
      [ngClass]="{ active: filterAvailabilityType === availabilityTypes.available }"
      aria-controls="available"
      aria-selected="false"
      (click)="onChangeFilterAvailabilityType(availabilityTypes.available)"
      i18n
    >
      Available
    </button>
    <button
      matTooltip="Show rentals booked during selected dates."
      matTooltipPosition="above"
      i18n-matTooltip
      class="btn calender-ctrl-btn text-nowrap"
      [ngClass]="{ active: filterAvailabilityType === availabilityTypes.booked }"
      aria-controls="booked"
      aria-selected="true"
      (click)="onChangeFilterAvailabilityType(availabilityTypes.booked)"
      i18n
    >
      Booked
    </button>
  </div>

  <div class="btn-group">
    <button
      class="btn btn-outline-light"
      matTooltip="Only show rentals with availability for these selected dates."
      i18n-matTooltip
      [ngbPopover]="tmplDateRangePicker"
      container="body"
      placement="bottom"
      autoClose="outside"
      popoverClass="popover-fill-content"
      #popoverDatePicker="ngbPopover"
    >
      <ng-container *ngIf="!filterAvailabilityDateRange; else dateRange">
        <i class="fal fa-calendar-exclamation"></i> <ng-container i18n>Range</ng-container>
      </ng-container>
      <ng-template #dateRange>
        {{
          (filterAvailabilityDateRange.from | epochUTC : 'DD/MM/YYYY') +
            ' - ' +
            (filterAvailabilityDateRange.to | epochUTC : 'DD/MM/YYYY')
        }}
      </ng-template>
      <ng-template #tmplDateRangePicker>
        <app-date-range-picker
          [selection]="filterAvailabilityDateRange"
          (selectionChange)="onChangeFilterDateRange($event); popoverDatePicker.close()"
          (click)="$event.stopPropagation()"
        >
        </app-date-range-picker>
      </ng-template>
    </button>
    <button class="btn btn-outline-danger" *ngIf="filterAvailabilityDateRange" (click)="onChangeFilterDateRange(null)">
      <i class="far fa-times"></i>
    </button>
  </div>
</ng-template>

<ng-template #tmplRateTooltip let-rental="rental" let-date="date" let-rate="rate">
  <app-rate-popover-v2
    [date]="date"
    [rate]="rate"
    [rental]="rental"
    [ratesByCategory]="getRentalCategoryRates(rental, date)"
  >
  </app-rate-popover-v2>
</ng-template>

<ng-template #tmplBookingTooltip let-rental="rental" let-event="event">
  <app-booking-tooltip-popup [rental]="rental" [bookingId]="event.bookingId"></app-booking-tooltip-popup>
</ng-template>

<ng-template #tmlHoldTooltip let-rental="rental" let-event="event">
  <app-hold-event-tooltip-popup [rental]="rental" [event]="event"></app-hold-event-tooltip-popup>
</ng-template>

<ng-template #addActions>
  <button
    type="button"
    class="btn btn-secondary-info dropdown-toggle"
    [disabled]="1 | isReadonlyRole"
    (click)="isPlusMenuOpen = true"
    cdkOverlayOrigin
    #plusMenuTrigger="cdkOverlayOrigin"
  >
    <span class="fal fa-calendar-plus"></span> <ng-container i18n>Add</ng-container>
  </button>
  <ng-template
    cdkConnectedOverlay
    (overlayOutsideClick)="isPlusMenuOpen = false"
    [cdkConnectedOverlayOffsetY]="10"
    [cdkConnectedOverlayOrigin]="plusMenuTrigger"
    [cdkConnectedOverlayOpen]="isPlusMenuOpen"
  >
    <div>
      <ul
        class="dropdown-menu show d-grid calendar-plus-menu"
        (click)="isPlusMenuOpen = false"
        style="position: initial; grid-template-columns: repeat(2, 320px)"
      >
        <ng-container *ngFor="let item of calendarPlusMenu; let index = index">
          <li *ngIf="!item.submenu?.length">
            <button
              class="text-left py-2 align-items-start"
              (mouseenter)="onMouseoverMainPlusMenuItem(item, index)"
              (click)="onMenuItemClick(item)"
            >
              <div>
                <i [ngClass]="item.icon"></i>
              </div>
              <div>
                <div class="text-semi-bold">{{ item.label }}</div>
                <div class="text-sm text-light text-wrap">{{ item.description }}</div>
              </div>
            </button>
          </li>
          <ng-container
            *ngIf="!!item.submenu?.length"
            [ngTemplateOutlet]="submenuTmpl"
            [ngTemplateOutletContext]="{ item: item, index: index }"
          >
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </ng-template>
</ng-template>

<ng-template #submenuTmpl let-item="item" let-index="index">
  <li
    (mouseenter)="onMouseoverMainPlusMenuItem(item, index)"
    cdkOverlayOrigin
    #menuTrigger="cdkOverlayOrigin"
    class="mt-3"
    style="grid-column: span 2"
  >
    <button class="text-left py-2 mx-1" [ngClass]="item.bg" #btn (click)="onMenuItemClick(item)">
      <div>
        <i [ngClass]="item.icon"></i>
      </div>
      <div>
        <div class="text-semi-bold">{{ item.label }}</div>
        <div class="text-sm text-light text-wrap">{{ item.description }}</div>
      </div>
    </button>
  </li>
  <ng-template
    cdkConnectedOverlay
    (overlayOutsideClick)="item.open = false"
    [cdkConnectedOverlayOffsetX]="-15"
    [cdkConnectedOverlayOffsetY]="-200"
    [cdkConnectedOverlayPositions]="[{ originX: 'start', originY: 'bottom', overlayX: 'end', overlayY: 'center' }]"
    [cdkConnectedOverlayOrigin]="menuTrigger"
    [cdkConnectedOverlayOpen]="item.open"
  >
    <div>
      <ul
        class="dropdown-menu show d-grid"
        (click)="item.open = false"
        style="position: initial; grid-template-columns: repeat(1, 320px)"
      >
        <li *ngFor="let subItem of item.submenu">
          <button class="text-left py-2 align-items-start" (click)="onMenuItemClick(subItem)">
            <div>
              <i [ngClass]="subItem.icon"></i>
            </div>
            <div>
              <div class="text-semi-bold">{{ subItem.label }}</div>
              <div class="text-sm text-light text-wrap">{{ subItem.description }}</div>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</ng-template>
